import type {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
} from '@reduxjs/toolkit/query/react';
import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import {
  clearAllAgentSessionIds,
  clearAllAgentSessionDocumentIds,
  clearAllAppStorage,
} from '../../utils/session';
export const AUTH_URL = process.env.REACT_APP_PROD_AUTH_URL;
export const PRODUCTS_URL = process.env.REACT_APP_PRODUCTS_URL;
export const DEV_URL = process.env.REACT_APP_DEV_URL;
const rawBaseQuery = fetchBaseQuery({
  baseUrl: AUTH_URL,
  credentials: 'include',
});

export const baseQueryWithReauth: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  const result = await rawBaseQuery(args, api, extraOptions);

  if (
    result.error &&
    (result.error.status === 401 || result.error.status === 403)
  ) {
    clearAllAgentSessionIds();
    clearAllAgentSessionDocumentIds();
    clearAllAppStorage();
    if (
      window.location.pathname !== '/' &&
      window.location.pathname !== '/login'
    ) {
      window.location.replace('/');
    }
  }

  return result;
};
